import { atom, useAtom } from "jotai";
import { atomFamily, atomWithHash } from "jotai/utils";

import { useAtomValue, useSetAtom } from "jotai";

import {
    BaseQuestionType,
    getEndExerciseInfo,
    getTopExerciseInfo
} from "../../exercise";
import _ from "underscore";
import { toNumber } from "../../service";
import { sum } from "utils/common";

// 练习id
export const exerciseIdAtom = atom(0);

// 练习结束统计信息
export const staticsAtom = atom(async get => {
    const exerciseId = get(exerciseIdAtom);
    return await getEndExerciseInfo(exerciseId);
});

// 统计试题总分值
export const totalScoreAtom = atom(get => {
    const staticInfo = get(staticsAtom);
    return sum(...staticInfo.questionList.map(item => toNumber(item.score)));
});

// 选中的id
export const selectedIdAtom = atomWithHash("id", 0, {
    replaceState: true,
    delayInit: true
});

// 选中的index
export const selectedIndexAtom = atom(get => {
    const selectedId = get(selectedIdAtom);
    const questionList = get(SortQuestionList);
    const index = questionList.findIndex(item => item.id === selectedId);
    return Math.max(index, 0);
});

// 上一题下一题
export const useNavigateQuestion = () => {
    const selectedIndex = useAtomValue(selectedIndexAtom);
    const questionList = useAtomValue(SortQuestionList);
    const setSelectedId = useSetAtom(selectedIdAtom);

    function goNext() {
        if (selectedIndex === questionList.length - 1) return;
        const next = questionList[selectedIndex + 1];
        if (next) setSelectedId(next.id);
    }

    function goPrev() {
        if (selectedIndex === 0) return;
        const next = questionList[selectedIndex - 1];
        if (next) setSelectedId(next.id);
    }

    function go(id: number) {
        setSelectedId(id);
    }

    return { goNext, goPrev, go, selectedIndex, questionList };
};

// 根据index获取题目信息
export const selectedQuestion = atomFamily((index: number) =>
    atom(get => {
        const list = get(SortQuestionList);
        if (list.length < index + 1) throw new Error("找不到试题");
        return get(SortQuestionList)[index];
    })
);

// 练习信息
export const exerciseInfoAtom = atom(async get => {
    const exerciseId = get(exerciseIdAtom);
    return await getTopExerciseInfo(exerciseId);
});

// 排序方式
export const SortTypeAtom = atom("");

// 排序
export function useSort() {
    const [sortType, setSortType] = useAtom(SortTypeAtom);

    return function onSort() {
        if (sortType === "") setSortType("asc");
        if (sortType === "asc") setSortType("desc");
        if (sortType === "desc") setSortType("");
    };
}

// 排序后的列表
export const SortQuestionList = atom(get => {
    const { questionList } = get(staticsAtom);
    const order = get(SortTypeAtom);

    if (!order) return questionList;

    return _.sortBy(questionList, item => {
        // 所有无法显示正确率的题都排到最后
        if (
            item.queTypeId >= BaseQuestionType.Mixed ||
            item.queTypeId === BaseQuestionType.Subjective
        )
            return Infinity;
        const percent = toNumber(item.accuracy.replace("%", ""));
        return order === "asc" ? percent : 0 - percent;
    });
});
